import { API_CONFIG, APP_CONFIG, QUICK_SIGNUP_STORAGE_KEY } from '../config/envConfig';

export const toCompanyWebsiteUrl = (value = '') => {
  const cleaned = value.trim().replace(/\/+$/, '');
  if (!cleaned) return '';
  if (/^https?:\/\//i.test(cleaned)) return cleaned;
  return `https://${cleaned}`;
};

export const looksLikeWebsite = (value = '') => {
  const cleaned = value.trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '');
  if (!cleaned || cleaned.includes(' ')) return false;
  return /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i.test(cleaned);
};

export const isQuickSignupAuthSuccess = (data) =>
  Boolean(data?.exchange_code) && !data.error;

export const isAccountExistsError = (data) =>
  typeof data?.error === 'string' && /already exists/i.test(data.error);

export const clearQuickSignupSession = () => {
  sessionStorage.removeItem(QUICK_SIGNUP_STORAGE_KEY);
};

/**
 * Hand off to the WhiteOwl app onboarding route via a one-time exchange_code.
 */
export const redirectToAppOnboarding = (data = {}) => {
  clearQuickSignupSession();

  const url = new URL(APP_CONFIG.onboardingPath, `${APP_CONFIG.appUrl}/`);
  if (data.exchange_code) url.searchParams.set('exchange_code', data.exchange_code);
  window.location.assign(url.toString());
};

/**
 * Buy Now (payment) signups: complete quick-signup with the post-payment
 * email+otp, then hand off to the app via the same one-time exchange_code
 * used by the standard OAuth flow (no raw tokens on the redirect URL).
 */
export const completeBuyNowSignup = async ({ email, otp, companyWebsite }) => {
  const completeRes = await fetch(API_CONFIG.quickSignupOauthCompleteUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, otp, company_website: companyWebsite }),
  });
  const completeData = await completeRes.json().catch(() => ({}));

  if (!completeRes.ok || completeData.error || !isQuickSignupAuthSuccess(completeData)) {
    throw new Error(completeData.error || completeData.message || 'Unable to complete signup. Please try again.');
  }

  redirectToAppOnboarding(completeData);
};
